import { AssetsTranslations, TranslationsMap } from "../CountryPage";

import firstSectionMobile from "../../../assets/images/ES/first-section-mobile_ES.jpg";
import firstSectionDesktop from "../../../assets/images/ES/first-section-desktop_ES.jpg";
import secondSectionMobile from "../../../assets/images/ES/second-section-mobile_ES.jpg";
import secondSectionDesktop from "../../../assets/images/ES/second-section-desktop_ES.jpg";
import thirdSectionMobile from "../../../assets/images/ES/third-section-mobile_ES.jpg";
import thirdSectionDesktop from "../../../assets/images/ES/third-section-desktop_ES.jpg";
import fourthSectionMobile from "../../../assets/images/ES/fourth-section-mobile_ES.jpg";
import fourthSectionDesktop from "../../../assets/images/ES/fourth-section-desktop_ES.jpg";

export const spanishTranslatedAssets: AssetsTranslations = {
  firstSectionMobile,
  firstSectionDesktop,
  secondSectionMobile,
  secondSectionDesktop,
  thirdSectionMobile,
  thirdSectionDesktop,
  fourthSectionMobile,
  fourthSectionDesktop,
};

export const spanishTranslations: TranslationsMap = {
  "landingPage.selection.title": "Bienvenida a Cora BC",
  "landingPage.selection.body": "Para leer información sobre el producto, elige a continuación tu país de residencia:",
  "landingPage.hero.title": "Tu apoyo en la vida con cáncer de mama",
  "landingPage.hero.body": "Comprender y gestionar tu cáncer de mama te ayudará a tener más confianza e información en tu día a día.",
  "landingPage.hero.preLaunch.cta": "Registrarse",
  "landingPage.hero.sponsored": "Cora BC (Reino Unido) está patrocinada por Novartis Pharmaceuticals UK Ltd.",
  "landingPage.usp.ho.label": "Vista de conjunto de salud",
  "landingPage.usp.ho.title": "Gestiona los cambios en tu salud",
  "landingPage.usp.ho.body": "Registra tus experiencias periódicamente para observar cualquier cambio en tu salud. Utiliza los gráficos informativos para sentir que tienes mayor control e información sobre tu cáncer de mama.",
  "landingPage.usp.ia.label": "Apoyo para cumplir el tratamiento",
  "landingPage.usp.ia.title": "Mantente al día con tu tratamiento",
  "landingPage.usp.ia.body": "Obtén apoyo con tu nueva rutina manteniendo tus complejos horarios de medicación en un solo lugar.",
  "landingPage.usp.si.label": "Mantente informada",
  "landingPage.usp.si.title": "Obtén contenido específico para ti",
  "landingPage.usp.si.body": "Recibe artículos recomendados que pueden ayudarte con tu experiencia personal y accede a ellos en cualquier momento y lugar. Aprende a tu propio ritmo y dedica tiempo adicional a los temas que consideres más importantes.",
  "landingPage.usp.cs.label": "Apoyo para consultas",
  "landingPage.usp.cs.title": "Empodérate cuidándote",
  "landingPage.usp.cs.body": "Mantén todas tus próximas citas en Cora. Siéntete preparada para participar activamente en conversaciones con tu médico escribiendo notas con ayuda de nuestras sugerencias temáticas.",
  "landingPage.moreFeatures.title": "...más funciones y ventajas de Cora BC",
  "landingPage.moreFeatures.feel.title": "Empodérate a través de la preparación",
  "landingPage.moreFeatures.feel.body": "Anota la información relevante y las preguntas que quieras hacer, para estar preparada para cubrir todos los temas importantes durante las consultas.",
  "landingPage.moreFeatures.discover.title": "Descubre un diseño intuitivo y fácil de usar",
  "landingPage.moreFeatures.discover.body": "Disfruta de una interfaz cómoda e intuitiva que facilita la navegación.",
  "landingPage.moreFeatures.tools.title": "Herramientas para ayudarte a organizar mejor tu día a día",
  "landingPage.moreFeatures.tools.body": "Personaliza tus notificaciones según el horario que más te convenga.",
  "landingPage.signUp.label": "Próximo lanzamiento de la aplicación",
  "landingPage.signUp.title": "Regístrate para recibir la notificación",
  "landingPage.signUp.body": "Cora BC se lanzará en diciembre de 2024. Regístrate con tu correo electrónico para recibir una notificación cuando la aplicación esté lista para descargar.",
  "landingPage.signUp.input.placeholder": "Introduce aquí tu correo electrónico",
  "landingPage.signUp.button": "Registrarse",
  "landingPage.signUp.disclaimer": "Al enviar tu correo electrónico, aceptas recibir información sobre el producto Cora BC.",
  "landingPage.signUp.complete.title": "Se ha enviado tu correo electrónico",
  "landingPage.signUp.complete.body": "Gracias por enviar tu correo electrónico. Recibirás un correo electrónico cuando Cora BC esté disponible para descargar.",
  "landingPage.footer.privacyPolicy": "Política de privacidad",
  "landingPage.footer.licenses": "Licencias",
  "landingPage.download.title": "Descargar Cora BC",
  "landingPage.download.body": "Tu apoyo en la vida con cáncer de mama. Descárgala gratis ahora.",
  "landingPage.topBar.label": "Disponible en diciembre de 2024",
  "landingPage.topBar.body": "Regístrate para recibir notificaciones sobre el lanzamiento",
  "landingPage.topBar.button": "Registrarse",
  "landingPage.companionApp": "Aplicación complementaria",
  "landingPage.coraBC": "Cora BC",
  "landingPage.mobile.countrySelection.australia": "Australia (No está disponible por ahora)",
  "landingPage.mobile.preLaunch.productInformation.signUp": "Regístrate para el lanzamiento",
  "mobile.preLaunch.productInformation.upcomingRelease": "Próximo lanzamiento",
  "landingPage.mobile.preLaunch.productInformation.sponsor": "Cora BC (Reino Unido) está patrocinada por Novartis Pharmaceuticals UK Ltd.",
  "landingPage.usp.ia.label.9": "Apoyo para cumplir el tratamiento",
  "landingPage.PrivacyPolicy": "Política de privacidad",
  "landingPage.back": "Atrás",
  "landingPage.mobile.postLaunch.productInformation.appStore": "App Store",
  "landingPage.mobile.postLaunch.productInformation.googlePlay": "Google Play",
};
